
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueDraggable from 'vuedraggable';
import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import api from './api';
import multilang from './multilang';
import { VueAutosuggest } from 'vue-autosuggest';
window.api=api;
window.Vue=Vue;
window.$=$;
import datetimepicker from './jquery.datetimepicker.full.min.js';

window.cventLink="/packages";

datepickerFactory($);

var VueComponents={};

var vueComponentList=[
  require.context(".", false, /.+\.vue$/),
];
for(var vueComponentListItem of vueComponentList)
  for(var key of vueComponentListItem.keys()) {
    let actualKey=key.replace(/\.vue|.*\//g, "");
    let actualComponent=vueComponentListItem(key).default;
    VueComponents[actualKey]=actualComponent;
    Vue.component(actualKey, actualComponent);
  }

Vue.config.ignoredElements = ['date']
Vue.use(multilang);

Vue.use(VueRouter);
Vue.component("draggable", VueDraggable);
Vue.component("vue-autosuggest", VueAutosuggest);
const router = new VueRouter({
  base: window.appData.base,
  mode: "history",
  routes: [
//     {path: "/", name: "home", component: VueComponents.homepage2},
    {path: "/", name: "home", component: VueComponents.homepage3},
    {path: "/packages", name: "packages", component: VueComponents.homepage2},
    {path: "/videos/:category", name: "category", component: VueComponents.homepage},
    {path: "/v/:group", name: "group", component: VueComponents.homepage},
    {path: "/videos/:category/:filter", name: "categoryfilter", component: VueComponents.homepage},
    {path: "/teachers", name: "teachers", component: VueComponents.teachers},
    {path: "/teachers/:id", name: "content.teacher", component: VueComponents.teacher},
//     {path: "/welcome", name: "content.welcome", component: VueComponents.welcome},
    {path: "/post/:id", name: "content", component: VueComponents.contentpage},
    {path: "/post/:id/:pid", name: "content.playlist", component: VueComponents.contentpage},
    {path: "/user/login", name: "user.login", component: VueComponents.userLogin},
    {path: "/user/register", name: "user.register", component: VueComponents.userRegister},
    {path: "/user/profile", name: "user.profile2", component: VueComponents.userProfile},
    {path: "/user/payment", name: "user.profile", component: VueComponents.userPayment},
    {path: "/user/payment/pp", name: "user.profilepp", component: VueComponents.userPaymentPp},
    {path: "/user/payment/success", name: "user.paysuccess", component: VueComponents.userPaymentSuccess},
    {path: "/user/payment/fail", name: "user.payfail", component: VueComponents.userPaymentFail},
    {path: "/admin/videos", name: "admin.videos", component: VueComponents.adminVideos},
    {path: "/admin/posts", name: "admin.posts", component: VueComponents.adminPosts},
    {path: "/admin/posts/:id", name: "content.postedit", component: VueComponents.editpage},
    {path: "/admin/users", name: "admin.users", component: VueComponents.adminUsers},
    {path: "/admin/types", name: "admin.types", component: VueComponents.adminTypes},
    {path: "/admin/specialities", name: "admin.specialities", component: VueComponents.adminSpecialities},
    {path: "/admin/aparatus", name: "admin.aparatus", component: VueComponents.adminAparatus},
    {path: "/admin/parts", name: "admin.parts", component: VueComponents.adminParts},
    {path: "/admin/props", name: "admin.props", component: VueComponents.adminProps},
    {path: "/admin/levels", name: "admin.levels", component: VueComponents.adminLevels},
    {path: "/admin/groups", name: "admin.groups", component: VueComponents.adminGroups},
    {path: "/admin/stats", name: "admin.stats", component: VueComponents.adminStats},
    {path: "/admin/tests", name: "admin.tests", component: VueComponents.adminTests},
    {path: "/admin/discounts", name: "admin.discounts", component: VueComponents.adminDiscount},
    {path: "*", name: "notfound", component: VueComponents.NotFound},
  ],
});

$("[vue-dyn]").each(function() {
  $(this).removeAttr("vue-dyn");
  new Vue({
    el: this,
    router: router
  });
});

